import axios from "axios";

// const BASE_URL = window.REACT_APP_WEBHOOK_URL || process.env.REACT_APP_WEBHOOK_URL;
const BASE_URL = 'https://n8n.cebugrandrealty.com/webhook';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

// Add request interceptor to add timestamp for cache busting
api.interceptors.request.use((config) => {
  // Add timestamp to prevent caching
  if (config.method === 'post' || config.method === 'get') {
    config.params = {
      ...config.params,
      _t: Date.now()
    };
  }
  return config;
});

export default api;